import yup from '#schema/locale';

const regexProfileTitle = /^.+$/;

const PeOnboardingSchemaPage2 = yup.object({
  profileTitle: yup
    .string()
    .required()
    .minSlug(3)
    .max(200)
    .matches(regexProfileTitle)
    .trim(),
});

export default PeOnboardingSchemaPage2;
